import { useGetContext } from "@onefront/forrestjs-react-root";
import VaporThemeProvider from "@vapor/react-material/styles";
import { createContext, useContext, useRef, useState } from "react";
import { b64Decode } from "../utils/b64-decode";
import { useQueryString } from "../utils/use-query-string";

export const VaporThemeContext = createContext();

export const useVaporTheme = () => useContext(VaporThemeContext);

export const ThemeProvider = ({ ...props }) => {
  // Attempt to read from the encoded session param at boot
  // NOTE: this has to be improved together with the SessionStorage to simplify
  const ctxParam = useGetContext("one.axios.sessions.param.key");
  const sessionParam = useGetContext("one.vapor.theme.session.param");
  const defaultTheme = useGetContext("one.vapor.theme.name");
  const qs = useQueryString();

  // TODO: improve this workaround to get this info at first render
  // and to memoize it into the DOM using the Ref.
  const sessionTheme = useRef(null);
  if (!sessionTheme.current) {
    try {
      const session = qs.getItem(ctxParam);
      sessionTheme.current = JSON.parse(b64Decode(session))[sessionParam];
    } catch (err) {
      sessionTheme.current = defaultTheme;
    }
  }

  // Use the first theme from the session, fallback on configuration
  const [theme, setTheme] = useState(sessionTheme.current);

  return (
    <VaporThemeContext.Provider value={{ theme, setTheme }}>
      <VaporThemeProvider {...props} name={theme} />
    </VaporThemeContext.Provider>
  );
};
